import { render, staticRenderFns } from "./AuthSignup.vue?vue&type=template&id=f6c46f42&scoped=true"
import script from "./AuthSignup.vue?vue&type=script&lang=ts"
export * from "./AuthSignup.vue?vue&type=script&lang=ts"
import style0 from "./AuthSignup.vue?vue&type=style&index=0&id=f6c46f42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c46f42",
  null
  
)

export default component.exports